<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Qualité à l'officine">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; La pharmacie est-elle engagée dans une démarche qualité ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.demarcheQualite"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="demarcheQualite"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="demarcheQualite"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Avez-vous réalisé l’auto-évaluation du CNOP ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.CNOPAutoEvaluation"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="CNOPAutoEvaluation"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="CNOPAutoEvaluation"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Réalisez-vous une démarche supplémentaire à celle du CNOP
                ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.CNOPDemarcheSupplementaire"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="CNOPDemarcheSupplementaire"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="CNOPDemarcheSupplementaire"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.CNOPDemarcheSupplementaire">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.CNOPDemarcheSupplementairePrecision"
                label="Si oui, précisez laquelle"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187;Disposez-vous de référentiels, normes ou certification
                dans votre officine ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.referentielNormeCertification"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="referentielNormeCertification"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="referentielNormeCertification"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="dossier.referentielNormeCertification">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.referentielNormeCertificationPrecision"
                label="Si oui, lesquels ?"
                required
                :rules="textRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Utilisez-vous le site
                https://www.demarchequaliteofficine.fr ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.siteDemarchequalite"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="siteDemarchequalite"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="siteDemarchequalite"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                Disposez-vous des procédures suivantes :
              </p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Gestion d’analyse des erreurs de dispensation ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.analyseErreur"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="analyseErreur"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="analyseErreur"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Gestion des produits thermolabiles ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.thermolabileGestion"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="thermolabileGestion"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="thermolabileGestion"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Gestion des alertes de retraits de lots de médicaments ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="dossier.alerteRetrait"
                row
                required
                :rules="radioRules"
              >
                <v-radio
                  label="oui"
                  name="alerteRetrait"
                  v-bind:value="true"
                  required
                ></v-radio>
                <v-radio
                  label="non"
                  name="alerteRetrait"
                  v-bind:value="false"
                  required
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" />
            <v-col cols="12" md="4">
              <p class="subtitle-1 text-left">
                &#187; Autres procédures ?
              </p></v-col
            >
            <v-col cols="12" md="6">
              <v-text-field
                v-model="dossier.autreProcedure"
                label="Autres procédures"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";

export default {
  name: "Partie12",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    menu: false,
    dateFormationEtp: null,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    numberRules: [
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "La superficie doit être composée uniquement de chiffres"
    ]
  }),
  computed: {
    formatedDate() {
      return this.dateFormationEtp
        ? moment(this.dateFormationEtp).format("DD/MM/YYYY")
        : "";
    }
  },
  created() {
    if (this.dossier.dateFormationEtp) {
      let unix_timestamp = this.dossier.dateFormationEtp;
      var date = new Date(unix_timestamp);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.dateFormationEtp = year + "-" + month + "-" + day;
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.dateFormationEtp = this.dateFormationEtp;
        if (!this.dossier.CNOPDemarcheSupplementaire)
          this.dossier.CNOPDemarcheSupplementairePrecision = null;
        if (!this.dossier.referentielNormeCertification)
          this.dossier.referentielNormeCertificationPrecision = null;
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
